var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagNl = function SvgIconFlagNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314688",
    d: "M19.535 14.666H4.465c1.098 3.103 4.05 5.33 7.528 5.333h.014c3.48-.003 6.43-2.23 7.528-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M4 12c0 .937.169 1.832.465 2.667h15.07A8 8 0 0 0 20 12c0-.937-.169-1.831-.465-2.666H4.465A8 8 0 0 0 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E1C33",
    d: "M4.465 9.334h15.07C18.437 6.23 15.485 4.003 12.005 4h-.011c-3.48.003-6.43 2.23-7.53 5.334"
  }))));
};
export { SvgIconFlagNl as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGZpbGw9IiMzMTQ2ODgiIGQ9Ik0xOS41MzUgMTQuNjY2SDQuNDY1YzEuMDk4IDMuMTAzIDQuMDUgNS4zMyA3LjUyOCA1LjMzM2guMDE0YzMuNDgtLjAwMyA2LjQzLTIuMjMgNy41MjgtNS4zMzMiLz48cGF0aCBmaWxsPSIjRkVGRUZFIiBkPSJNNCAxMmMwIC45MzcuMTY5IDEuODMyLjQ2NSAyLjY2N2gxNS4wN0E3Ljk2IDcuOTYgMCAwMDIwIDEyYzAtLjkzNy0uMTY5LTEuODMxLS40NjUtMi42NjZINC40NjVBNy45NTQgNy45NTQgMCAwMDQgMTIiLz48cGF0aCBmaWxsPSIjOUUxQzMzIiBkPSJNNC40NjUgOS4zMzRoMTUuMDdDMTguNDM3IDYuMjMgMTUuNDg1IDQuMDAzIDEyLjAwNSA0aC0uMDExYy0zLjQ4LjAwMy02LjQzIDIuMjMtNy41MyA1LjMzNCIvPjwvZz48L3N2Zz4=";